export type SafetyRecallLike = {
  campaign_number?: string | null;
};

/**
 * Ford/Lincoln: exclude M and N campaign codes (maintenance, not safety).
 * Other OEMs: keep recalls that have a campaign number (GM uses N-prefix NHTSA IDs).
 */
export function filterSafetyRecallsForMapDisplay<T extends SafetyRecallLike>(
  safetyRecalls: T[],
  makeName: string | undefined | null
): T[] {
  const m = (makeName || '').toLowerCase().trim();
  const isFordOem = m === 'ford' || m === 'lincoln';
  return filterSafetyRecallsForMapDisplayByOem(safetyRecalls, isFordOem);
}

/**
 * When vehicle make is unavailable, use OEM flag (e.g. spatial clustering context).
 */
export function filterSafetyRecallsForMapDisplayByOem<T extends SafetyRecallLike>(
  safetyRecalls: T[],
  isFordOem: boolean
): T[] {
  if (isFordOem) {
    return safetyRecalls.filter(recall => {
      const campaignNumber = recall.campaign_number || '';
      return !campaignNumber.includes('M') && !campaignNumber.includes('N');
    });
  }
  return safetyRecalls.filter(recall => !!(recall.campaign_number || ''));
}
